module.exports = __webpack_public_path__ + "media/images/battery-60-604d58b00b3a03bea2c6c51bd29eedcc.png";